<template>
  <!-- <v-app>
    <v-main> -->
      <Navbar />
      <router-view/>
    <!-- </v-main>
  </v-app> -->
</template>

<script>
import Navbar from '@/components/Navbar.vue'
  

export default {
  name: 'App',
  components: { Navbar }
}
</script>



<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }

  html, body{
      height: 100%;
      margin: 0px;
      padding: 0px;
  }

  body {
      display: flex;
      flex-direction: column;
      background-color: rgb(243 244 246);
  }
  .footer{
      flex-shrink: 0;
  }

  /* SCROLLBAR */
  ::-webkit-scrollbar { /* width */
  width: 6px;
  }
  ::-webkit-scrollbar-track { /* Track */
  background: #f1f1f1;
  }
  ::-webkit-scrollbar-thumb { /* Handle */
  background: #888;
  }
  ::-webkit-scrollbar-thumb:hover { /* Handle on hover */
  background: #555;
  }
    
  </style>
  